import { SerializeUrlFraudReport } from './urlFraudReportSerializer';
import { reportTypes, serializedTypes } from '../../types';

type UrlFraudReportSerializer = (
  rawReport: reportTypes.Report
) => serializedTypes.SerializedUrlFraudReport;
export class UrlFraudReport {
  public data: serializedTypes.SerializedUrlFraudReport;

  constructor(
    rawData: reportTypes.Report,
    serializer: UrlFraudReportSerializer = SerializeUrlFraudReport
  ) {
    this.data = serializer(rawData);
  }
}
